<p-dialog
  [(visible)]="visible"
  (visibleChange)="closeModal()"
  [modal]="true"
  [style]="{ width: '90vw', maxWidth: '600px' }"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'bills-purchase-modal ' + (billType ? 'bill-type-' + billType.color : '')"
  [closeOnEscape]="!isProcessing()"
>
  <ng-template pTemplate="header">
    <div class="modal-header">
      <div class="header-icon">
        @if (billType?.icon === 'phone') {
          <i class="pi pi-phone"></i>
        } @else if (billType?.icon === 'wifi') {
          <i class="pi pi-wifi"></i>
        } @else if (billType?.icon === 'tv') {
          <i class="pi pi-desktop"></i>
        } @else if (billType?.icon === 'bolt') {
          <i class="pi pi-bolt"></i>
        }
      </div>
      <div>
        <h2 class="modal-title">{{ billType?.name }} Payment</h2>
        <p class="modal-subtitle">{{ billType?.description }}</p>
      </div>
    </div>
  </ng-template>

  <div class="modal-body">
    <!-- Airtime Form -->
    @if (billType?.id === 'airtime') {
      <div class="purchase-form">
        <div class="form-group">
          <label class="form-label">Select Network *</label>
          <select
            class="form-control"
            [ngModel]="selectedServiceId()"
            (ngModelChange)="selectedServiceId.set($event)"
            [style]="{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db' }"
          >
            <option value="">Choose network...</option>
            @for (service of airtimeServices; track service.id) {
              <option [value]="service.id">{{ service.name }}</option>
            }
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Amount (₦) *</label>
          <p-inputNumber
            [ngModel]="amount()"
            (ngModelChange)="amount.set($event ?? null)"
            [min]="50"
            [max]="50000"
            currency="NGN"
            mode="decimal"
            [style]="{ width: '100%' }"
            placeholder="Enter amount (₦50 - ₦50,000)"
          ></p-inputNumber>
          <small class="form-hint">Minimum: ₦50, Maximum: ₦50,000</small>
        </div>

        <div class="form-group">
          <label class="form-label">Phone Number *</label>
          <input
            type="tel"
            pInputText
            [(ngModel)]="phoneNumber"
            placeholder="e.g., 08012345678"
            maxlength="11"
            [style]="{ width: '100%' }"
          />
        </div>

        <!-- Payment Method Selection -->
        <div class="form-group">
          <label class="form-label">Payment Method *</label>
          <div class="payment-method-selection">
            <div class="payment-option">
              <input
                type="radio"
                id="shoppingCard-airtime"
                name="paymentMethod-airtime"
                [value]="'shoppingCard'"
                [checked]="paymentMethod() === 'shoppingCard'"
                (change)="paymentMethod.set('shoppingCard'); selectedCardId.set(null)"
              />
              <label for="shoppingCard-airtime" class="payment-label">
                <i class="pi pi-wallet"></i>
                <span>Shopping Card</span>
              </label>
            </div>
            @if (supportsSavedCards()) {
              <div class="payment-option">
                <input
                  type="radio"
                  id="savedCard-airtime"
                  name="paymentMethod-airtime"
                  [value]="'savedCard'"
                  [checked]="paymentMethod() === 'savedCard'"
                  (change)="paymentMethod.set('savedCard')"
                  [disabled]="savedCards().length === 0"
                />
                <label for="savedCard-airtime" class="payment-label" [class.disabled]="savedCards().length === 0">
                  <i class="pi pi-credit-card"></i>
                  <span>Saved Card</span>
                  @if (savedCards().length === 0) {
                    <small class="no-cards-hint">(No saved cards)</small>
                  }
                </label>
              </div>
            }
          </div>
        </div>

        <!-- Saved Card Selection -->
        @if (supportsSavedCards() && paymentMethod() === 'savedCard') {
          <div class="form-group">
            <label class="form-label">Select Card *</label>
            @if (isLoadingCards()) {
              <div class="loading-cards">
                <p-progressSpinner [style]="{ width: '20px', height: '20px' }"></p-progressSpinner>
                <span>Loading cards...</span>
              </div>
            } @else if (savedCards().length === 0) {
              <div class="no-cards-message">
                <p>No saved cards available. <a [routerLink]="['/cards']" [queryParams]="{ platformId: platformId }">Add a card</a></p>
              </div>
            } @else {
              <div class="cards-list">
                @for (card of savedCards(); track card.id) {
                  <div
                    class="card-item"
                    [class.selected]="selectedCardId() === card.id"
                    (click)="selectedCardId.set(card.id)"
                  >
                    <div class="card-info">
                      <div class="card-type-badge">{{ card.cardType || 'Card' }}</div>
                      <div class="card-number">{{ getMaskedCardNumber(card.last4) }}</div>
                      <div class="card-bank">{{ card.bank || 'N/A' }}</div>
                    </div>
                    <div class="card-check">
                      @if (selectedCardId() === card.id) {
                        <i class="pi pi-check-circle"></i>
                      } @else {
                        <i class="pi pi-circle"></i>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        <div class="form-group">
          <label class="form-label">Transaction PIN *</label>
          <input
            type="password"
            pInputText
            [ngModel]="transactionPin()"
            (ngModelChange)="transactionPin.set($event)"
            placeholder="Enter your 4-6 digit PIN"
            minlength="4"
            maxlength="6"
            [style]="{ width: '100%' }"
          />
          <small class="form-hint">Your 4-6 digit transaction PIN</small>
        </div>

        <!-- Proceed to Pay Button -->
        <div class="form-group form-actions">
          <button
            type="button"
            class="proceed-pay-btn"
            (click)="processPurchase()"
            [disabled]="isProcessing() || (paymentMethod() === 'savedCard' && !selectedCardId())"
          >
            @if (isProcessing()) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            <span>PROCEED TO PAY</span>
          </button>
        </div>
      </div>
    }

    <!-- Data Form -->
    @if (billType?.id === 'data') {
      <div class="purchase-form">
        <div class="form-group">
          <label class="form-label">Select Network *</label>
          <select
            class="form-control"
            [ngModel]="selectedServiceId()"
            (ngModelChange)="selectedServiceId.set($event); onDataServiceChange()"
            [style]="{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db' }"
          >
            <option value="">Choose network...</option>
            @for (service of dataServices; track service.id) {
              <option [value]="service.id">{{ service.name }}</option>
            }
          </select>
        </div>

        <div class="form-group">
          <label class="form-label">Billing Period *</label>
          <select
            class="form-control"
            [ngModel]="selectedPeriod()"
            (ngModelChange)="selectedPeriod.set($event); onPeriodChange()"
            [style]="{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db' }"
          >
            <option value="">Choose period...</option>
            @for (period of billingPeriods(); track period.id) {
              <option [value]="period.id">{{ period.name }}</option>
            }
          </select>
        </div>

        @if (isLoadingPlans()) {
          <div class="loading-plans">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }"></p-progressSpinner>
            <span>Loading data plans...</span>
          </div>
        }

        @if (dataPlans().length > 0) {
          <div class="form-group">
            <label class="form-label">Select Data Plan *</label>
            <div class="plans-list">
              @for (plan of dataPlans(); track plan.id) {
                <div
                  class="plan-item"
                  [class.selected]="selectedDataPlan()?.id === plan.id"
                  (click)="onDataPlanSelect(plan)"
                >
                  <div class="plan-info">
                    <div class="plan-name">{{ plan.name }}</div>
                    <div class="plan-amount">₦{{ plan.amount | number:'1.2-2' }}</div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <div class="form-group">
          <label class="form-label">Phone Number *</label>
          <input
            type="tel"
            pInputText
            [(ngModel)]="phoneNumber"
            placeholder="e.g., 08012345678"
            maxlength="11"
            [style]="{ width: '100%' }"
          />
        </div>

        <!-- Payment Method Selection -->
        <div class="form-group">
          <label class="form-label">Payment Method *</label>
          <div class="payment-method-selection">
            <div class="payment-option">
              <input
                type="radio"
                id="shoppingCard-data"
                name="paymentMethod-data"
                [value]="'shoppingCard'"
                [checked]="paymentMethod() === 'shoppingCard'"
                (change)="paymentMethod.set('shoppingCard'); selectedCardId.set(null)"
              />
              <label for="shoppingCard-data" class="payment-label">
                <i class="pi pi-wallet"></i>
                <span>Shopping Card</span>
              </label>
            </div>
            @if (supportsSavedCards()) {
              <div class="payment-option">
                <input
                  type="radio"
                  id="savedCard-data"
                  name="paymentMethod-data"
                  [value]="'savedCard'"
                  [checked]="paymentMethod() === 'savedCard'"
                  (change)="paymentMethod.set('savedCard')"
                  [disabled]="savedCards().length === 0"
                />
                <label for="savedCard-data" class="payment-label" [class.disabled]="savedCards().length === 0">
                  <i class="pi pi-credit-card"></i>
                  <span>Saved Card</span>
                  @if (savedCards().length === 0) {
                    <small class="no-cards-hint">(No saved cards)</small>
                  }
                </label>
              </div>
            }
          </div>
        </div>

        <!-- Saved Card Selection -->
        @if (supportsSavedCards() && paymentMethod() === 'savedCard') {
          <div class="form-group">
            <label class="form-label">Select Card *</label>
            @if (isLoadingCards()) {
              <div class="loading-cards">
                <p-progressSpinner [style]="{ width: '20px', height: '20px' }"></p-progressSpinner>
                <span>Loading cards...</span>
              </div>
            } @else if (savedCards().length === 0) {
              <div class="no-cards-message">
                <p>No saved cards available. <a [routerLink]="['/cards']" [queryParams]="{ platformId: platformId }">Add a card</a></p>
              </div>
            } @else {
              <div class="cards-list">
                @for (card of savedCards(); track card.id) {
                  <div
                    class="card-item"
                    [class.selected]="selectedCardId() === card.id"
                    (click)="selectedCardId.set(card.id)"
                  >
                    <div class="card-info">
                      <div class="card-type-badge">{{ card.cardType || 'Card' }}</div>
                      <div class="card-number">{{ getMaskedCardNumber(card.last4) }}</div>
                      <div class="card-bank">{{ card.bank || 'N/A' }}</div>
                    </div>
                    <div class="card-check">
                      @if (selectedCardId() === card.id) {
                        <i class="pi pi-check-circle"></i>
                      } @else {
                        <i class="pi pi-circle"></i>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        }

        <div class="form-group">
          <label class="form-label">Transaction PIN *</label>
          <input
            type="password"
            pInputText
            [ngModel]="transactionPin()"
            (ngModelChange)="transactionPin.set($event)"
            placeholder="Enter your 4-6 digit PIN"
            minlength="4"
            maxlength="6"
            [style]="{ width: '100%' }"
          />
          <small class="form-hint">Your 4-6 digit transaction PIN</small>
        </div>

        <!-- Proceed to Pay Button -->
        <div class="form-group form-actions">
          <button
            type="button"
            class="proceed-pay-btn"
            (click)="processPurchase()"
            [disabled]="isProcessing()"
          >
            @if (isProcessing()) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            <span>PROCEED TO PAY</span>
          </button>
        </div>
      </div>
    }

    <!-- Electricity Form -->
    @if (billType?.id === 'electricity') {
      <div class="purchase-form">
        <div class="form-group">
          <label class="form-label">Select Electricity Provider *</label>
          <select
            class="form-control"
            [ngModel]="selectedServiceId()"
            (ngModelChange)="selectedServiceId.set($event); onElectricityServiceChange()"
            [style]="{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db' }"
          >
            <option value="">Choose provider...</option>
            @for (service of electricityServices; track service.id) {
              <option [value]="service.id">{{ service.name }}</option>
            }
          </select>
        </div>

        @if (isLoadingPlans()) {
          <div class="loading-plans">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }"></p-progressSpinner>
            <span>Loading meter types...</span>
          </div>
        }

        @if (discoPlans().length > 0) {
          <div class="form-group">
            <label class="form-label">Select Meter Type *</label>
            <div class="plans-list">
              @for (plan of discoPlans(); track plan.id) {
                <div
                  class="plan-item"
                  [class.selected]="selectedDiscoPlan()?.id === plan.id"
                  (click)="onDiscoPlanSelect(plan)"
                >
                  <div class="plan-info">
                    <div class="plan-name">{{ plan.name }}</div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <div class="form-group">
          <label class="form-label">Meter Number *</label>
          <div class="input-with-button">
            <input
              type="text"
              pInputText
              [ngModel]="meterNumber()"
              (ngModelChange)="meterNumber.set($event)"
              placeholder="Enter meter number"
              [style]="{ width: '100%', flex: 1 }"
            />
            <button
              pButton
              label="Validate"
              (click)="validateMeterNumber()"
              [disabled]="!meterNumber() || !selectedDiscoPlan() || isValidating()"
              [loading]="isValidating()"
              class="p-button-secondary"
            ></button>
          </div>
          @if (validatedCustomer()) {
            <div class="validation-success">
              <i class="pi pi-check-circle"></i>
              <span>{{ validatedCustomer().customerName }}</span>
            </div>
          }
        </div>

        @if (validatedCustomer()) {
          <div class="form-group">
            <label class="form-label">Amount (₦) *</label>
            <p-inputNumber
              [ngModel]="amount()"
              (ngModelChange)="amount.set($event ?? null)"
              [min]="validatedCustomer()?.minAmount || 100"
              currency="NGN"
              mode="decimal"
              [style]="{ width: '100%' }"
              placeholder="Enter amount"
            ></p-inputNumber>
            <small class="form-hint">Minimum: ₦{{ validatedCustomer()?.minAmount || 100 }}</small>
          </div>

          <!-- Payment Method Selection -->
          <div class="form-group">
            <label class="form-label">Payment Method *</label>
            <div class="payment-method-selection">
              <div class="payment-option">
                <input
                  type="radio"
                  id="shoppingCard-electricity"
                  name="paymentMethod-electricity"
                  [value]="'shoppingCard'"
                  [checked]="paymentMethod() === 'shoppingCard'"
                  (change)="paymentMethod.set('shoppingCard'); selectedCardId.set(null)"
                />
                <label for="shoppingCard-electricity" class="payment-label">
                  <i class="pi pi-wallet"></i>
                  <span>Shopping Card</span>
                </label>
              </div>
              @if (supportsSavedCards()) {
                <div class="payment-option">
                  <input
                    type="radio"
                    id="savedCard-electricity"
                    name="paymentMethod-electricity"
                    [value]="'savedCard'"
                    [checked]="paymentMethod() === 'savedCard'"
                    (change)="paymentMethod.set('savedCard')"
                    [disabled]="savedCards().length === 0"
                  />
                  <label for="savedCard-electricity" class="payment-label" [class.disabled]="savedCards().length === 0">
                    <i class="pi pi-credit-card"></i>
                    <span>Saved Card</span>
                    @if (savedCards().length === 0) {
                      <small class="no-cards-hint">(No saved cards)</small>
                    }
                  </label>
                </div>
              }
            </div>
          </div>

          <!-- Saved Card Selection -->
          @if (supportsSavedCards() && paymentMethod() === 'savedCard') {
            <div class="form-group">
              <label class="form-label">Select Card *</label>
              @if (isLoadingCards()) {
                <div class="loading-cards">
                  <p-progressSpinner [style]="{ width: '20px', height: '20px' }"></p-progressSpinner>
                  <span>Loading cards...</span>
                </div>
              } @else if (savedCards().length === 0) {
                <div class="no-cards-message">
                  <p>No saved cards available. <a [routerLink]="['/cards']" [queryParams]="{ platformId: platformId }">Add a card</a></p>
                </div>
              } @else {
                <div class="cards-list">
                  @for (card of savedCards(); track card.id) {
                    <div
                      class="card-item"
                      [class.selected]="selectedCardId() === card.id"
                      (click)="selectedCardId.set(card.id)"
                    >
                      <div class="card-info">
                        <div class="card-type-badge">{{ card.cardType || 'Card' }}</div>
                        <div class="card-number">{{ getMaskedCardNumber(card.last4) }}</div>
                        <div class="card-bank">{{ card.bank || 'N/A' }}</div>
                      </div>
                      <div class="card-check">
                        @if (selectedCardId() === card.id) {
                          <i class="pi pi-check-circle"></i>
                        } @else {
                          <i class="pi pi-circle"></i>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div class="form-group">
            <label class="form-label">Transaction PIN *</label>
            <input
              type="password"
              pInputText
              [ngModel]="transactionPin()"
            (ngModelChange)="transactionPin.set($event)"
              placeholder="Enter your 4-6 digit PIN"
              minlength="4"
              maxlength="6"
              [style]="{ width: '100%' }"
            />
            <small class="form-hint">Your 4-6 digit transaction PIN</small>
          </div>
        }

        <!-- Proceed to Pay Button -->
        <div class="form-group form-actions">
          <button
            type="button"
            class="proceed-pay-btn"
            (click)="processPurchase()"
            [disabled]="isProcessing() || (paymentMethod() === 'savedCard' && !selectedCardId())"
          >
            @if (isProcessing()) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            <span>PROCEED TO PAY</span>
          </button>
        </div>
      </div>
    }

    <!-- Cable Form -->
    @if (billType?.id === 'cable') {
      <div class="purchase-form">
        <div class="form-group">
          <label class="form-label">Select Cable Provider *</label>
          <select
            class="form-control"
            [ngModel]="selectedServiceId()"
            (ngModelChange)="selectedServiceId.set($event); onCableServiceChange()"
            [style]="{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #d1d5db' }"
          >
            <option value="">Choose provider...</option>
            @for (service of cableServices; track service.id) {
              <option [value]="service.id">{{ service.name }}</option>
            }
          </select>
        </div>

        @if (isLoadingPlans()) {
          <div class="loading-plans">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }"></p-progressSpinner>
            <span>Loading cable plans...</span>
          </div>
        }

        @if (cablePlans().length > 0) {
          <div class="form-group">
            <label class="form-label">Select Cable Plan *</label>
            <div class="plans-list">
              @for (plan of cablePlans(); track plan.id) {
                <div
                  class="plan-item"
                  [class.selected]="selectedCablePlan()?.id === plan.id"
                  (click)="onCablePlanSelect(plan)"
                >
                  <div class="plan-info">
                    <div class="plan-name">{{ plan.name }}</div>
                    <div class="plan-amount">₦{{ plan.amount | number:'1.2-2' }}</div>
                  </div>
                </div>
              }
            </div>
          </div>
        }

        <div class="form-group">
          <label class="form-label">Smart Card Number *</label>
          <div class="input-with-button">
            <input
              type="text"
              pInputText
              [ngModel]="smartCardNumber()"
              (ngModelChange)="smartCardNumber.set($event)"
              placeholder="Enter smart card number"
              [style]="{ width: '100%', flex: 1 }"
            />
            <button
              pButton
              label="Validate"
              (click)="validateSmartCard()"
              [disabled]="!smartCardNumber() || !selectedCablePlan() || isValidating()"
              [loading]="isValidating()"
              class="p-button-secondary"
            ></button>
          </div>
          @if (validatedCableCustomer()) {
            <div class="validation-success">
              <i class="pi pi-check-circle"></i>
              <span>{{ validatedCableCustomer().customerName }}</span>
            </div>
          }
        </div>

        @if (validatedCableCustomer()) {
          <!-- Payment Method Selection -->
          <div class="form-group">
            <label class="form-label">Payment Method *</label>
            <div class="payment-method-selection">
              <div class="payment-option">
                <input
                  type="radio"
                  id="shoppingCard-cable"
                  name="paymentMethod-cable"
                  [value]="'shoppingCard'"
                  [checked]="paymentMethod() === 'shoppingCard'"
                  (change)="paymentMethod.set('shoppingCard'); selectedCardId.set(null)"
                />
                <label for="shoppingCard-cable" class="payment-label">
                  <i class="pi pi-wallet"></i>
                  <span>Shopping Card</span>
                </label>
              </div>
              @if (supportsSavedCards()) {
                <div class="payment-option">
                  <input
                    type="radio"
                    id="savedCard-cable"
                    name="paymentMethod-cable"
                    [value]="'savedCard'"
                    [checked]="paymentMethod() === 'savedCard'"
                    (change)="paymentMethod.set('savedCard')"
                    [disabled]="savedCards().length === 0"
                  />
                  <label for="savedCard-cable" class="payment-label" [class.disabled]="savedCards().length === 0">
                    <i class="pi pi-credit-card"></i>
                    <span>Saved Card</span>
                    @if (savedCards().length === 0) {
                      <small class="no-cards-hint">(No saved cards)</small>
                    }
                  </label>
                </div>
              }
            </div>
          </div>

          <!-- Saved Card Selection -->
          @if (supportsSavedCards() && paymentMethod() === 'savedCard') {
            <div class="form-group">
              <label class="form-label">Select Card *</label>
              @if (isLoadingCards()) {
                <div class="loading-cards">
                  <p-progressSpinner [style]="{ width: '20px', height: '20px' }"></p-progressSpinner>
                  <span>Loading cards...</span>
                </div>
              } @else if (savedCards().length === 0) {
                <div class="no-cards-message">
                  <p>No saved cards available. <a [routerLink]="['/cards']" [queryParams]="{ platformId: platformId }">Add a card</a></p>
                </div>
              } @else {
                <div class="cards-list">
                  @for (card of savedCards(); track card.id) {
                    <div
                      class="card-item"
                      [class.selected]="selectedCardId() === card.id"
                      (click)="selectedCardId.set(card.id)"
                    >
                      <div class="card-info">
                        <div class="card-type-badge">{{ card.cardType || 'Card' }}</div>
                        <div class="card-number">{{ getMaskedCardNumber(card.last4) }}</div>
                        <div class="card-bank">{{ card.bank || 'N/A' }}</div>
                      </div>
                      <div class="card-check">
                        @if (selectedCardId() === card.id) {
                          <i class="pi pi-check-circle"></i>
                        } @else {
                          <i class="pi pi-circle"></i>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <div class="form-group">
            <label class="form-label">Transaction PIN *</label>
            <input
              type="password"
              pInputText
              [ngModel]="transactionPin()"
            (ngModelChange)="transactionPin.set($event)"
              placeholder="Enter your 4-6 digit PIN"
              minlength="4"
              maxlength="6"
              [style]="{ width: '100%' }"
            />
            <small class="form-hint">Your 4-6 digit transaction PIN</small>
          </div>
        }

        <!-- Proceed to Pay Button -->
        <div class="form-group form-actions">
          <button
            type="button"
            class="proceed-pay-btn"
            (click)="processPurchase()"
            [disabled]="isProcessing() || (paymentMethod() === 'savedCard' && !selectedCardId())"
          >
            @if (isProcessing()) {
              <i class="pi pi-spin pi-spinner"></i>
            }
            <span>PROCEED TO PAY</span>
          </button>
        </div>
      </div>
    }
  </div>
</p-dialog>

<p-toast position="bottom-right"></p-toast>
